import { createReducer, on } from "@ngrx/store";
import * as productsActions from './related-actions';
import * as fromProducts from './related-state';

const initialState: fromProducts.State = {
  isLoading:false,
  payload:{},
  data:[]
};
export const reducer = createReducer(
  initialState,
  on(productsActions.LoadingRelatedProductsAction, (state,payload) => {
    return {...state,isLoading:true,payload}
  }),
  on(productsActions.ResetRelatedProductsAction, (state,payload) => {
    return {...state,isLoading:false,data:[]}
  }),
  on(productsActions.ListRelatedProductsAction, (state,{data}) => {
    return {...state,isLoading:false,data};
  }),
  on(productsActions.ErrorRelatedProductsAction, (state) => {
    return {...state, isLoading: false};
  }),
  on(productsActions.CancelRelatedProductRequestAction, (state) => {
    return {...state, isLoading: false};
  }),
);
